import { PARENT_ROUTE as ADMIN_PARENT_ROUTE } from '../admin';

const PARENT_ROUTE = '/roleplay';
const ADMIN_ROLEPLAY_PARENT_ROUTE = `${ADMIN_PARENT_ROUTE}${PARENT_ROUTE}`;

const adminRoleplayRoutes = {
  AdminRoleplayDetails: (roleplayId: string) =>
    `${ADMIN_ROLEPLAY_PARENT_ROUTE}/${roleplayId}/details`,
  RoleplayEditor: (roleplayId: string) => `${ADMIN_ROLEPLAY_PARENT_ROUTE}/${roleplayId}/edit`,
};

const learnerRoleplayRoutes = {
  RoleplayDetails: (roleplayId: string) => `${PARENT_ROUTE}/${roleplayId}/details`,
};

export const roleplayDetailRoute = (roleplayId: string) => ({
  admin: adminRoleplayRoutes.AdminRoleplayDetails(roleplayId),
  learner: learnerRoleplayRoutes.RoleplayDetails(roleplayId),
});

const routes = {
  ...adminRoleplayRoutes,
  ...learnerRoleplayRoutes,
};

export const ADMIN_ROLEPLAY_ROUTE_KEYS = {
  AdminRoleplayDetails: 'AdminRoleplayDetails',
  RoleplayEditor: 'RoleplayEditor',
};

export const LEARNER_ROLEPLAY_ROUTE_KEYS = {
  RoleplayDetails: 'RoleplayDetails',
};

export const ROLEPLAY_ROUTE_KEYS = {
  ...ADMIN_ROLEPLAY_ROUTE_KEYS,
  ...LEARNER_ROLEPLAY_ROUTE_KEYS,
};

export default routes;
